export enum ECompanySize {
    NotMentioned = 0,
    LessThanFiveEmployees = 1,
    UptoTenEmployees = 2,
    UptoTwentyFiveEmployees = 3,
    UptoFiftyEmployees = 4,
    MoreThanFiftyEmployees = 5
}